import Vue from 'vue';

const EventBus = new Vue();

/**
 * EventBus.$emit('EVENT_NAME', payLoad);
 * import EventBus from './event-bus';
 * EventBus.$on(‘EVENT_NAME’, function (payLoad) {
 *   ...
 * });
 */

export default EventBus;
